<template lang="pug">
  div
    h5.overflow-hidden
      | {{ title }}
      |
      RouterLink.btn.btn-default.btn-sm.btn-icon(
        v-if="routes.create"
        :to="{name: routes.create}"
      )
        i.fa.fa-plus
    p(v-if="!items.length") {{ $t('forms.empty') }}
    BCard(v-else)
      BTableSimple(hover responsive)
        BThead(head-variant="light")
          BTr
            BTh
              button(@click="toggleSort('id')")
                | #
                i.fas.fa-sort-amount-down-alt.sort(v-if="sort === 'id'")
                i.fas.fa-sort-amount-down.sort(v-if="sort === '-id'")
            BTh(
              v-for="column in table"
              :key="column.code"
            )
              button(@click="column.sort ? toggleSort(column.code) : null")
                | {{ $t(`forms.fields.${column.code}`) }}
                i.fas.fa-sort-amount-down-alt.sort(v-if="sort === column.code")
                i.fas.fa-sort-amount-down.sort(v-if="sort === `-${column.code}`")
            BTh
        BTbody
          BaseRow(
            v-for="item in items"
            :key="item.id"
            :routeKey="routeKey"
            :routes="routes"
            :table="table"
            :item="item"
            :onDelete="onDelete"
          )
      BPagination(
        align="center"
        v-if="showPagination"
        :value="page"
        @input="changePage"
        :totalRows="totalRows"
        :perPage="perPage"
      )
</template>

<script>
import BaseRow from './BaseRow'

export default {
  components: { BaseRow },
  props: {
    title: { type: String, required: true },
    routeKey: { type: String, required: true },
    routes: { type: Object, required: true },
    table: { type: Array, required: true },
    items: { type: Array, required: true },
    meta: { type: Object, required: false },
    sort: { type: String, required: false },
    page: { type: Number, required: false },
    onDelete: { type: Function, required: true },
    toggleSort: { type: Function, required: true },
    changePage: { type: Function, required: true }
  },
  computed: {
    totalRows: vm => vm.meta?.total || 0,
    perPage: vm => vm.meta?.per_page || 20,
    showPagination: vm => vm.totalRows > vm.perPage
  }
}
</script>

<style lang="sass" scoped>
table th button
  border: none
  background: none
  padding: 0 20px 0 0
  outline: none
  position: relative

  i.sort
    position: absolute
    right: 0
    top: 5px
</style>
